// extracted by mini-css-extract-plugin
export var active = "Modal-module--active--42a53";
export var button = "Modal-module--button--13bcf";
export var close = "Modal-module--close--f2e08";
export var cross = "Modal-module--cross--bcdf7";
export var heading = "Modal-module--heading--5105e";
export var logo = "Modal-module--logo--b618b";
export var modal = "Modal-module--modal--2c201";
export var search = "Modal-module--search--b054a";